import { render, staticRenderFns } from "./ManageOption.vue?vue&type=template&id=1cafb0c8&"
import script from "./ManageOption.vue?vue&type=script&lang=js&"
export * from "./ManageOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cafb0c8')) {
      api.createRecord('1cafb0c8', component.options)
    } else {
      api.reload('1cafb0c8', component.options)
    }
    module.hot.accept("./ManageOption.vue?vue&type=template&id=1cafb0c8&", function () {
      api.rerender('1cafb0c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/tools/components/ManageOption.vue"
export default component.exports